// src/routes/AppRoutes.jsx
import { Routes, Route, Navigate } from "react-router-dom";

// Layouts
import MainLayout from "../layouts/MainLayout";
import HomeScreen from "../layouts/mobile/HomeScreen";
import FavoritesScreen from "../layouts/mobile/FavoritesScreen";
import SettingsScreen from "../layouts/mobile/SettingsScreen";
import NotificationSettingsScreen from "../layouts/mobile/NotificationSettingsScreen";
import WorkHubScreen from "../layouts/mobile/WorkHubScreen";
import CrmHubScreen from "../layouts/mobile/CrmHubScreen";
import {
  FinanceHubScreen,
  ElearningHubScreen,
  HrmHubScreen,
} from "../layouts/mobile/MobileModuleHubScreen";
import MoreScreen from "../layouts/mobile/MoreScreen";
import ReportsHubScreen from "../layouts/mobile/ReportsHubScreen";
import MobileWorkListScreen from "../layouts/mobile/work/MobileWorkListScreen";
import MobileCrmFollowupsScreen from "../layouts/mobile/crm/MobileCrmFollowupsScreen";
import MobileProfile from "../modules/hrm/profile/MobileProfile";

// System Modules
import LoginPage from "../components/auth/LoginPage";
import ForgotPasswordPage from "../components/auth/ForgotPasswordPage";
import ResetPasswordPage from "../components/auth/ResetPasswordPage";
import ProtectedLayout from "../components/auth/ProtectedLayout";
import RegisterPage from "../components/auth/RegisterPage";

// CRM Modules
import DashboardCRM from "../modules/crm/DashboardCRM_01";
import CustomerListPage from "../modules/crm/customers/CustomerListPage";
import TeacherAccountCardPage from "../modules/crm/teacher-accounts/TeacherAccountCardPage";
import ContractListPage from "../modules/crm/contracts/ContractListPage";
import ContactHistoryListPage from "../modules/crm/contact-history/ContactHistoryListPage";
import ContractLinkedDossierPage from "../modules/crm/documents/ContractLinkedDossierPage";

// HRM Modules
import DashboardHRM from "../modules/hrm/DashboardHRM_01";
import BranchListPage from "../modules/hrm/branches/BranchListPage";
// import EmployeeListPage from '../modules/hrm/employees/EmployeeListPage';
import EmployeeListPage from "../modules/hrm/employees/EmployeeCardPage";
import PlanListPage from "../modules/hrm/plan/PlanListPage";
import TaskMainListPage from "../modules/hrm/tasks/pages/TaskMainListPage";

import EmployeeAttendanceLogListPage from "../modules/hrm/attendance/AttendanceLogListPage";
import OverTimeListPage from "../modules/hrm/overtime/OverTimeListPage";
import BusinessTripListPage from "../modules/hrm/businessTrip/BusinessTripListPage";
import OnLeaveListPage from "../modules/hrm/onLeave/OnLeaveListPage";
import InternalDocuments from "../modules/hrm/documents/DocumentCardPage";
import MyPayslipPage from "../modules/hrm/payroll/MyPayslipPage";
import SigningRequestListPage from "../modules/hrm/signing/SigningRequestListPage";
import SigningPdfPage from "../modules/hrm/signing/SigningPdfPage";

// E-Learning Modules
import DashboardElearning from "../modules/elearning/DashboardPage_01";
import GcsCostDashboardPage from "../modules/settings/gcs_cost/GcsCostDashboardPage";
import DocumentCardPage from "../modules/elearning/documents/DocumentCardPage";
import StudentListPage from "../modules/elearning/students/StudentListPage";
import SubjectCardPage from "../modules/elearning/subjects/SubjectCardPage";
import CourseListPage from "../modules/elearning/courses/CourseCardPage";
import LessonCardPage from "../modules/elearning/lessons/LessonCardPage";
import ClassCardPage from "../modules/elearning/classes/ClassListPage";
import AttendancePage from "../modules/elearning/attendance/AttendancePage";
import ResultsPage from "../modules/elearning/results/ResultsPage";

// import CalendarList from "../modules/elearning/calendar/CalendarList";
import CalendarList from "../modules/elearning/schedule/ScheduleDashboard";
import CertificateManager from "../modules/elearning/certificates/CertificateManager";

// Finance Modules
import DashboardFinance from "../modules/finance/DashboardFinance_01";
import AdvanceListPage from "../modules/finance/advance/AdvanceListPage";
import PaymentListPage from "../modules/finance/payment-requests/PaymentListPage";
import IncomeExpenditurePage from "../modules/finance/income-expenditure/IncomeExpenditurePage";
import InvoiceListPage from "../modules/finance/invoices/InvoiceListPage";
import SalaryListPage from "../modules/finance/salary/SalaryListPage";

// Settings Modules
import RoleListPage from "../modules/settings/role_manager/RoleListPage";
import PermissionList from "../modules/settings/permissions/PermissionListPage";
import RolePermissionsManager from "../modules/settings/permission_manager/PermissionManager";
import UserRoleListPage from "../modules/settings/user_roles/UserRoleListPage";
import UsageRolePage from "../modules/settings/usage_roles/UsageRolePage";
import UserAccessAuditPage from "../modules/settings/user_access/UserAccessAuditPage";
import NotificationsPage from "../modules/settings/notifications/NotificationsPage";
import NotificationsListPage from "../modules/settings/notifications/page/NotificationsListPage";
import SignatureAssetListPage from "../modules/settings/signature_assets/SignatureAssetListPage";
import AppVersionsPage from "../modules/settings/app_versions/AppVersionsPage";

// Reports Modules
import TaskReportList from "../modules/reports/tasks/TaskReportList";
import FinanceCashflowReportPage from "../modules/reports/finance/FinanceCashflowReportPage";
import FinanceCollectionsReportPage from "../modules/reports/finance/FinanceCollectionsReportPage";

import PermissionWrapper from "../components/auth/PermissionWrapper";

function AppRoutes() {
  return (
    <Routes>
      {/* ✅ Public route (không dùng MainLayout) */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/m/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* Mobile Layout - sử dụng MainLayout để phân biệt */}
      <Route path="/m/*" element={<MainLayout />}>
        <Route index element={<Navigate to="/m/login" replace />} />{" "}
        {/* Mặc định chuyển đến login */}
        <Route path="home" element={<HomeScreen />} />
        <Route path="work" element={<WorkHubScreen />} />
        <Route path="work/:mode" element={<MobileWorkListScreen />} />
        <Route path="crm" element={<CrmHubScreen />} />
        <Route path="crm/followups" element={<MobileCrmFollowupsScreen />} />
        <Route path="finance" element={<FinanceHubScreen />} />
        <Route path="elearning" element={<ElearningHubScreen />} />
        <Route path="hrm" element={<HrmHubScreen />} />
        <Route path="reports" element={<ReportsHubScreen />} />
        <Route path="more" element={<MoreScreen />} />
        <Route path="favorites" element={<FavoritesScreen />} />
        <Route path="settings" element={<SettingsScreen />} />
        <Route
          path="settings/notifications"
          element={<NotificationSettingsScreen />}
        />
        <Route path="profile" element={<MobileProfile />} />
      </Route>

      {/* ✅ Protected route (được bọc trong MainLayout) */}
      <Route path="/*" element={<ProtectedLayout />}>
        <Route index element={<Navigate to="/login" replace />} />{" "}
        {/* Mặc định chuyển đến login */}
        {/* <Route path="crm" element={<div>Module CRM (coming soon)</div>} />
        <Route path="hrm" element={<div>Module HRM (coming soon)</div>} />
        <Route path="elearning" element={<div>Dashboard (coming soon)</div>} />
        <Route path="finance" element={<div>Module Finance (coming soon)</div>} />
        <Route path="report" element={<div>Module Report (coming soon)</div>} />
        <Route path="notify" element={<div>Notify (coming soon)</div>} />      
        <Route path="settings" element={<div>Settings (coming soon)</div>} /> */}
        {/* CRM Routes */}
        <Route
          path="crm/dashboard"
          element={
            <PermissionWrapper permissionCode="crm.dashboard" action="R">
              <DashboardCRM />
            </PermissionWrapper>
          }
        />
        <Route
          path="crm/customers"
          element={
            <PermissionWrapper permissionCode="crm.customers" action="R">
              <CustomerListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="crm/teacher_accounts"
          element={
            <PermissionWrapper permissionCode="crm.teacher_accounts" action="R">
              <TeacherAccountCardPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="crm/contracts"
          element={
            <PermissionWrapper permissionCode="crm.contracts" action="R">
              <ContractListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="crm/contact_history"
          element={
            <PermissionWrapper permissionCode="crm.contact_history" action="R">
              <ContactHistoryListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="crm/documents"
          element={
            <PermissionWrapper permissionCode="crm.documents" action="R">
              <ContractLinkedDossierPage />
            </PermissionWrapper>
          }
        />
        {/* HRM Routes */}
        <Route
          path="hrm/dashboard"
          element={
            <PermissionWrapper permissionCode="hrm.dashboard" action="R">
              <DashboardHRM />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/branches"
          element={
            <PermissionWrapper permissionCode="hrm.branches" action="R">
              <BranchListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/employees"
          element={
            <PermissionWrapper permissionCode="hrm.employees" action="R">
              <EmployeeListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/plans"
          element={
            <PermissionWrapper permissionCode="hrm.plans" action="R">
              <PlanListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/tasks"
          element={
            <PermissionWrapper permissionCode="hrm.tasks" action="R">
              <TaskMainListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/hrm_attendance"
          element={
            <PermissionWrapper permissionCode="hrm.attendance" action="R">
              <EmployeeAttendanceLogListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/overtime"
          element={
            <PermissionWrapper permissionCode="hrm.overtime" action="R">
              <OverTimeListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/business_trip"
          element={
            <PermissionWrapper permissionCode="hrm.business_trip" action="R">
              <BusinessTripListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/on_leave"
          element={
            <PermissionWrapper permissionCode="hrm.on_leave" action="R">
              <OnLeaveListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/hrm_documents"
          element={
            <PermissionWrapper permissionCode="hrm.documents" action="R">
              <InternalDocuments />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/signing"
          element={
            <PermissionWrapper permissionCode="hrm.signing" action="R">
              <SigningRequestListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/signing/:id/sign"
          element={
            <PermissionWrapper permissionCode="hrm.signing" action="A">
              <SigningPdfPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="hrm/my_payslip"
          element={
            <PermissionWrapper permissionCode="hrm.my_payslip" action="R">
              <MyPayslipPage />
            </PermissionWrapper>
          }
        />
        {/* E-Learning Routes */}
        <Route
          path="elearning/dashboard"
          element={
            <PermissionWrapper permissionCode="elearning.dashboard" action="R">
              <DashboardElearning />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/students"
          element={
            <PermissionWrapper permissionCode="elearning.students" action="R">
              <StudentListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/subjects"
          element={
            <PermissionWrapper permissionCode="elearning.subjects" action="R">
              <SubjectCardPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/courses"
          SubjectCardPage
          element={
            <PermissionWrapper permissionCode="elearning.courses" action="R">
              <CourseListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/edu_documents"
          element={
            <PermissionWrapper permissionCode="elearning.documents" action="R">
              <DocumentCardPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/lessons"
          element={
            <PermissionWrapper permissionCode="elearning.lessons" action="R">
              <LessonCardPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/classes"
          element={
            <PermissionWrapper permissionCode="elearning.classes" action="R">
              <ClassCardPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/calendar"
          element={
            <PermissionWrapper permissionCode="elearning.calendar" action="R">
              <CalendarList />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/edu_attendance"
          element={
            <PermissionWrapper permissionCode="elearning.attendance" action="R">
              <AttendancePage />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/results"
          element={
            <PermissionWrapper permissionCode="elearning.results" action="R">
              <ResultsPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="elearning/certificates"
          element={
            <PermissionWrapper
              anyOf={[
                { permissionCode: "elearning.certificates", action: "R" },
                { permissionCode: "elearning.certificates.request", action: "R" },
              ]}
            >
              <CertificateManager />
            </PermissionWrapper>
          }
        />
        {/* Finance Routes */}
        <Route
          path="finance/dashboard"
          element={
            <PermissionWrapper permissionCode="finance.dashboard" action="R">
              <DashboardFinance />
            </PermissionWrapper>
          }
        />
        <Route
          path="finance/advance"
          element={
            <PermissionWrapper
              permissionCode="finance.advance.access"
              action="R"
            >
              <AdvanceListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="finance/payment_requests"
          element={
            <PermissionWrapper
              permissionCode="finance.payment_requests"
              action="R"
            >
              <PaymentListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="finance/income_expenditure"
          element={
            <PermissionWrapper
              permissionCode="finance.income_expenditure"
              action="R"
            >
              <IncomeExpenditurePage />
            </PermissionWrapper>
          }
        />
        <Route
          path="finance/invoices"
          element={
            <PermissionWrapper permissionCode="finance.invoices" action="R">
              <InvoiceListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="finance/salary"
          element={
            <PermissionWrapper permissionCode="finance.salary" action="R">
              <SalaryListPage />
            </PermissionWrapper>
          }
        />
        {/* Settings Routes */}
        <Route
          path="settings/gcs_cost"
          element={
            <PermissionWrapper permissionCode="elearning.documents" action="R">
              <GcsCostDashboardPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/signature_assets"
          element={
            <PermissionWrapper permissionCode="settings.signature_assets" action="R">
              <SignatureAssetListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/roles"
          element={
            <PermissionWrapper permissionCode="settings.roles" action="R">
              <RoleListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/permissions"
          element={
            <PermissionWrapper permissionCode="settings.permissions" action="R">
              <PermissionList />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/role_permissions"
          element={
            <PermissionWrapper
              permissionCode="settings.role_permissions"
              action="R"
            >
              <RolePermissionsManager />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/usage_roles"
          element={
            <PermissionWrapper permissionCode="settings.usage_roles" action="R">
              <UsageRolePage />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/user_access"
          element={
            <PermissionWrapper permissionCode="settings.usage_roles" action="R">
              <UserAccessAuditPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/user_roles"
          element={
            <PermissionWrapper permissionCode="settings.user_roles" action="R">
              <UserRoleListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="system/notifications"
          element={
            <PermissionWrapper permissionCode="system.notifications" action="R">
              <NotificationsPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/notifications"
          element={
            <PermissionWrapper permissionCode="system.notifications" action="C">
              <NotificationsListPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="settings/app_versions"
          element={
            <PermissionWrapper permissionCode="system.version" action="R">
              <AppVersionsPage />
            </PermissionWrapper>
          }
        />
        {/* Reports Routes */}
        <Route
          path="reports/reports_tasks"
          element={
            <PermissionWrapper permissionCode="reports.tasks" action="R">
              <TaskReportList />
            </PermissionWrapper>
          }
        />
        <Route
          path="reports/finance_cashflow"
          element={
            <PermissionWrapper permissionCode="reports.finance" action="R">
              <FinanceCashflowReportPage />
            </PermissionWrapper>
          }
        />
        <Route
          path="reports/finance_collections"
          element={
            <PermissionWrapper permissionCode="reports.finance" action="R">
              <FinanceCollectionsReportPage />
            </PermissionWrapper>
          }
        />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
